<template>
  <div id="app">
    <div class="app__loading" v-if="!authStateChecked || dashboardNotRendered">
      <img src="@/assets/imgs/gifs/loading.gif" alt="loading...">
    </div>
    <router-view v-if="authStateChecked" />
    <InProcess />
    <Errors />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import InProcess from '@/components/InProcess'
import Errors from '@/components/Errors'
// services
import db from '@/services/db'

export default {
  name: 'App',
  components: {
    InProcess,
    Errors
  },
  computed: {
    ...mapState([
      'authStateChecked',
      'userId',
      'caslRules',
      'dashboardNotRendered'
    ])
  },
  watch: {
    userId () {
      if (!this.userId) return
      db.access.admin(this.userId, (actions) => {
        if (actions) {
          let rule = this.$buildACLRule('Admin', actions)
          this.$store.commit('updateCaslRules', rule)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '~$scss/fonts';
@import '~$scss/guideline';

#app {
  position: relative;
  overflow: hidden;
  > div {
    overflow: hidden;
  }
}

.app {
  &__loading {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    z-index: 1000;
    background: white;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue